<div class="master-detail">
    <div class="master">
        @for (item of profileList(); track $index) {

        <button (click)="select(item)" [class]="isSelected(item) ? 'card-click-selected' : 'card-click'">
            {{item.profile.firstName}} {{item.profile.lastName}}
        </button>
        }
    </div>

    <div class="details">
        @if(this.selectedProfile() === null || this.selectedProfile() === undefined)
        {
        <div class="details-not-selected">
            <p>No expert selected</p>
        </div>
        }@else {
        <app-profile-details [profile]="this.selectedProfileInfo" [relevance]="selectedProfile()?.relevance" />
        }

    </div>
</div>